import { render, staticRenderFns } from "./BaseBlocoTotalizador.vue?vue&type=template&id=4a8fdfa9&scoped=true&lang=pug"
import script from "./BaseBlocoTotalizador.vue?vue&type=script&lang=js"
export * from "./BaseBlocoTotalizador.vue?vue&type=script&lang=js"
import style0 from "./BaseBlocoTotalizador.vue?vue&type=style&index=0&id=4a8fdfa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8fdfa9",
  null
  
)

export default component.exports